module.exports = __webpack_public_path__ + "static/media/testimonial_bg.3e65fbfb.png";